document.querySelectorAll('.cb-cards[data-layout="scroll"], .cb-testimonials[data-layout="multi"]').forEach(block => {
	const container = block.querySelector('.h-scroll-container');
	const cardsWrapper = block.querySelector('.h-scroll-card-set');
	const prevBtn = block.querySelector('.scroll-prev');
	const nextBtn = block.querySelector('.scroll-next');

	let cardPositions = [];
	let scrollAmount = 0;

	// Calculate card positions and scroll amount
	const updateLayout = () => {
		const card = cardsWrapper.querySelector('.card');
		if (!card) return;

		const gap = parseInt(getComputedStyle(cardsWrapper).gap) || 0;
		scrollAmount = card.offsetWidth + gap;

		const containerPadding = parseFloat(getComputedStyle(cardsWrapper).paddingLeft) || 0;
		cardPositions = Array.from(cardsWrapper.children).map(c => c.offsetLeft - containerPadding);
	};

	// Initial calculation
	updateLayout();

	// Recalculate on resize
	window.addEventListener('resize', updateLayout);

	// Update button states at scroll edges
	const updateButtons = () => {
		prevBtn.disabled = container.scrollLeft <= 0;
		nextBtn.disabled = container.scrollLeft + container.clientWidth >= container.scrollWidth - 1;
	};

	// Scroll one card at a time
	prevBtn.addEventListener('click', () => {
		container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
	});

	nextBtn.addEventListener('click', () => {
		container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
	});

	container.addEventListener('scroll', updateButtons);
	window.addEventListener('resize', updateButtons);
	updateButtons();

	// Hide controls if not scrollable
	const updateScrollState = () => {
		const isScrollable = container.scrollWidth > container.clientWidth;
		const controls = block.querySelector('.h-scroll-controls');

		// Hide/show controls
		if (controls) {
			controls.style.display = isScrollable ? 'flex' : 'none';
		}
	};

	updateScrollState();
	window.addEventListener('resize', updateScrollState);

	// Snap to nearest card after scrolling stops
	let isScrolling;
	container.addEventListener('scroll', () => {
		window.clearTimeout(isScrolling);
		isScrolling = setTimeout(() => {
			if (!cardPositions.length) return;

			const currentScroll = container.scrollLeft;
			const maxScroll = container.scrollWidth - container.clientWidth;

			// If we're at or near the end, don't snap - stay at max scroll
			if (currentScroll >= maxScroll - 10) {
				container.scrollTo({ left: maxScroll, behavior: 'smooth' });
				return;
			}

			// Find nearest card position
			const nearest = cardPositions.reduce(
				(prev, curr) => Math.abs(curr - currentScroll) < Math.abs(prev - currentScroll) ? curr : prev,
				cardPositions[0]
			);

			container.scrollTo({ left: nearest, behavior: 'smooth' });
		}, 100);
	});
});
